import { window } from '../../../../../globals';

/**
 * Get the portal URL for a given slug
 */
export function getPortalUrl(slug: string | null): string | null {
  if (!slug || !window.portalUrl) {
    return null;
  }

  return `${window.portalUrl}/p/${slug}`;
}
